export default __webpack_public_path__ + "static/media/dragAndDropFormBuilder.90ee65e8.svg";